import { isIOS } from 'react-device-detect';

export const EVENT_PAGE = {
  PROMOTION: 'promotion',
  NOTI_PRE_REG: 'notiPreReg',
};

export const EVENT_REQUEST = {
  AGREE: 'agree',
  PRE_REQUEST: 'preRequest',
};

export const MEDIA_NAME = {
  SKT: 'skt',
  KT: 'kt',
  LGU: 'lgu',
};

export const JOB_TYP = {
  OFFICE_WORKER: '01', //직장인
  PUBLIC_OFFICIAL: '02', //공무원
  PROFESSION: '03', //전문직
  BUSINESS_MAN: '04', //개인 사업자
  FREELANCER: '05', //프리랜서
  IN_OCCUPATION: '99', //무직
};

export const HEALTH_CARD_TYP = {
  EMPLOYEE_HEALTH_INSURANCE: '01', //직장인의료보험
  LOCAL_HEALTH_INSURANCE: '02', //지역의료보험
};
// 매체 추가 시 미디어 코드 추가
// C008
export const MEDIA_CODE: { [key: string]: any } = {
  SKT: '01',
  skt: '01',
  KT: '02',
  kt: '02',
  LGU: '03',
  lgu: '03',
};

export const SORT_KEY = {
  LOW_RATE: 1,
  MAX_AMOUNT: 2,
};

// APP BRIDGE CODE
export const OPEN_WEBVIEW_TYPE = {
  IN: 'I',
  OUT: 'O',
};

export const PRE_REQUEST_CHECK_RESULT = {
  SUCCESS: 'SUCCESS',
  RETRY: 'RETRY',
};

export const enum OS_TYPE {
  IOS = 'iOS',
  Android = 'AND',
}

export const enum PAGE_NM {
  HOME = 'main.landing',
  CREDIT_HOME = 'main.credit',
  PARTNERS = 'lndr.list',
  TERMS = 'terms.cre',
  CONDITIONS_STEP1 = 'all.ssn',
  CONDITIONS_STEP1_CONFIRM = 'all.ssn.confirm',
  CONDITIONS_STEP2 = 'all.loanwish',
  CONDITIONS_STEP3 = 'gen.biz',
  CONDITIONS_STEP4_EMPLOYEE = 'gen.biz',
  CONDITIONS_STEP4_FREELANCER = 'finc.info',
  CONDITIONS_STEP4_SELFEMPLOYEE = 'ind.biz',
  CONDITIONS_STEP5 = 'all.addinfo',
  LOADING = 'rec.loading',
  RESULT_FAIL = 'rec.fail',
  RESULT = 'rec.succ',
  PRE_DETAIL = 'loan.info',
  DETAIL = 'loan.req',
  WORKING = 'main.staging',
  NOTI_PRE_REG = 'noti.reg',
  NOTI_PRE_INFORMS = 'noti.informs',
  RATE_CALCULATOR = 'loan.ratecalc',
  LOAN_INFO = 'loan.progress',
  PROMOTION = 'promotion',
  RESULT_EMPTY = 'empty',
  // 주담대
  MTG_HOME = 'main.mtg',
  MTG_PARTNERS = 'mtg.lndr',
  MTG_TERMS = 'terms.mtg',
  MTG_PURPOSE = 'mtg.loanwish',
  MTG_NUM = 'mtg.num',
  MTG_SELECT = 'mtg.select',
  MTG_TENANT = 'mtg.tenant',
  MTG_INCOME = 'mtg.income',
  MTG_CREDIT = 'mtg.credit',
  MTG_CONFIRM = 'mtg.confirm',
  MTG_SSN = 'mtg.ssn',
  MTG_SSN_CONFIRM = 'mtg.ssn.confirm',
  MTG_LOADING = 'mtg.recload',
  MTG_RESULT_FAIL = 'mtg.fail',
  MTG_RESULT = 'mtg.recsucc',
  MTG_SURVEY = 'mtg.survey',
  MTG_CHECK = 'mtg.check',
  MTG_DETAIL = 'mtg.info',
  MTG_CALL_TIME = 'call.time',
  MTG_CALL_REQ = 'call.req',
  MTG_LOAN_REQ = 'mtg.req',
  MTG_STATUS = 'req.list',
  MTG_RESULT_EMPTY = 'mtg.empty',
  SURVEY = 'mtg.survey',
}

export const OsType = isIOS ? OS_TYPE.IOS : OS_TYPE.Android;

export const enum INACTIVE_BUTTON_TYPE {
  promotion_participate = 'promotion_participate',
  pre_request_today = 'pre_request_today',
}

export const enum PLACEMENT_TYPE {
  loan_main_top = 'loan_main_top',
  loan_pre_request_result = 'loan_pre_request_result',
  loan_same_day_reentry = 'loan_same_day_reentry',
}

export const enum LANDING_TYPE {
  in_app = 'in_app',
  out_link = 'out_link',
  in_link = 'in_link',
}

export const enum LINK_TYPE_PROMOTION {
  terms = 'terms',
  credit_loan = 'credit_loan',
  mtg_loan = 'house_loan',
}

export const enum IN_APP_LANDING_TYPE {
  S_EB_HOME = 'S_EB_HOME', //SKT_금융광고_홈탭
  S_EB_LOAN = 'S_EB_LOAN', //SKT_금융광고_대출탭
  S_PA_HOME = 'S_PA_HOME', //SKT_PASS홈

  K_EB_HOME = 'K_EB_HOME', //KT_금융광고_홈탭
  K_EB_LOAN = 'K_EB_LOAN', //KT_금융광고_대출탭
  K_PA_HOME = 'K_PA_HOME', //KT_PASS홈
  K_MD_CS = 'K_MD_CS', //KT_마이데이터_신용점수보기
  K_MD_CB = 'K_MD_CB', //KT_마이데이터_신용점수부스팅

  K_MD_CREDIT = 'K_MD_CREDIT', // KT 신용지키미
  K_LB_CREDIT = 'K_LB_CREDIT', // KT 신용점수 영향없어요. 신용지키미

  L_EB_HOME = 'L_EB_HOME', //LGU_금융광고_홈탭
  L_EB_LOAN = 'L_EB_LOAN', //LGU_금융광고_대출탭
  L_PA_HOME = 'L_PA_HOME', //LGU_PASS홈
}

export const enum EVENT_NOTI_PRE_REG {
  monthlyRequestYn = 'Y',
  agreeYn = 'N',
}
